export default {
  root: {
    color: '#1e88e5',
    display: 'inline',
  },
};
